import React from 'react';
import { Helmet } from 'react-helmet';

export type SchemaType = 'MedicalOrganization' | 'Physician';

export interface PhysicianSchemaData {
  name: string;
  image?: string;
  url?: string;
  jobTitle?: string;
  medicalSpecialty?: string[];
}

export interface MedicalOrgSchemaData {
  name: string;
  url: string;
  logo: string;
  description: string;
  telephone?: string;
}

export interface SchemaMarkupProps {
  type: SchemaType;
  data: PhysicianSchemaData | MedicalOrgSchemaData;
}

export function SchemaMarkup({ type, data }: SchemaMarkupProps) {
  const generateSchema = () => {
    switch (type) {
      case 'MedicalOrganization': {
        const orgData = data as MedicalOrgSchemaData;
        return {
          '@context': 'https://schema.org',
          '@type': 'MedicalOrganization',
          name: orgData.name,
          url: orgData.url,
          logo: orgData.logo,
          description: orgData.description,
          telephone: orgData.telephone,
        };
      }
      case 'Physician': {
        const physData = data as PhysicianSchemaData;
        return {
          '@context': 'https://schema.org',
          '@type': 'Physician',
          name: physData.name,
          image: physData.image,
          url: physData.url,
          jobTitle: physData.jobTitle,
          medicalSpecialty: physData.medicalSpecialty,
        };
      }
      default:
        return null;
    }
  };

  const schema = generateSchema();

  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
